import {useEffect,useState} from 'react';
import type {DomainRegistrationService} from '../src/domain-registration';
import type {ErrorDetails} from './lib/types';
import {request,errorDetails} from './lib/store';
import {ErrorNotice,Loading,dateTime} from './components';

type Observations=Awaited<ReturnType<DomainRegistrationService['setupObservations']>>;
export function DomainConnectionStatus({id}:{id:string}){
  const [data,setData]=useState<Observations|null>(null),[error,setError]=useState<ErrorDetails|null>(null);
  useEffect(()=>{
    setData(null);setError(null);
    const controller=new AbortController();let timer:ReturnType<typeof setTimeout>;
    const read=async()=>{
      try{const result=await request<Observations>(`/account/domains/${encodeURIComponent(id)}/setup`,{signal:controller.signal});if(!controller.signal.aborted){setData(result);setError(null);}}
      catch(error){if(!controller.signal.aborted)setError(errorDetails(error));}
      if(!controller.signal.aborted)timer=setTimeout(()=>{if(document.visibilityState==='visible')void read();else timer=setTimeout(()=>void read(),30000);},30000);
    };
    void read();return()=>{controller.abort();clearTimeout(timer);};
  },[id]);
  return <section><h3>Connection status</h3><Loading active={!data&&!error}/><ErrorNotice error={error}/>{data&&<>
    <p>{data.application?`Selected app: ${data.application.slug}. Process: ${data.application.state}.`:'No app is connected.'}</p>
    {data.application&&<p>App folder: {data.application.definition.kind==='static'?data.application.definition.directory:data.application.definition.cwd}</p>}
    <ErrorNotice error={data.application?.error?errorDetails(data.application.error):null}/>
    <p>Nameservers: {data.registrar.nameservers.join(', ')}. Checked {dateTime(data.registrar.observedAt)}.</p>
    {data.dns.recursive.addresses.map(row=><div key={row.hostname}>
      <p>{row.hostname}: {row.result?.join(', ')??'No address returned'}. Checked {dateTime(row.observedAt)}.</p>
      <ErrorNotice error={row.error?{name:'DomainDnsError',...row.error}:null}/>
    </div>)}
    {data.http.map(row=><div key={row.url}>
      <p>{row.url}: {row.result?`HTTP ${row.result.status}. HTTPS certificate verified.`:'No HTTPS response.'} Checked {dateTime(row.observedAt)}.</p>
      {row.result?.location&&<p>Redirect: {row.result.location}</p>}
      <ErrorNotice error={row.error?{name:'DomainHttpError',...row.error}:null}/>
    </div>)}
  </>}</section>;
}
